module.exports = __webpack_public_path__ + "static/media/rainbow-flare.e455dfb6.png";